import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from 'gatsby-image'

const Navbar = (props) =>
{
  const [isActive, setisActive] = React.useState(false);

  const data = useStaticQuery(graphql`
  query {
    allImageSharp {
      edges {
        node {
          fluid(maxWidth: 3000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
  `)
  return (
    <nav className="navbar is-black has-centered-logo is-fixed-top" role="navigation" aria-label="main navigation" style={{ backgroundColor: '#181818' }}>
      <div className="navbar-brand is-hidden-desktop">
        <div class="pt-2 pl-2 pr-2">
          <AnchorLink class="navbar-item" to={props.page + "#hero-section"} >
            <StaticImage
              src="../images/Logo.png"
              width={120}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Dutch Tyres"
            />
          </AnchorLink>
        </div>
        <a
          onClick={() =>
          {
            setisActive(!isActive);
          }}

          role="button"
          className={`navbar-burger burger ${isActive ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div className={`navbar-menu ${isActive ? "is-active" : ""}`}>
        <div class="navbar-start">
          <AnchorLink className="navbar-item nav-links mainfont" to={props.page + "#intro-section"}>{props.introduction}</AnchorLink>
          <AnchorLink className="navbar-item nav-links mainfont" to={props.page + "#purchase-section"} >{props.purchase}</AnchorLink>
          <AnchorLink className="navbar-item nav-links mainfont" to={props.page + "#sales-section"} >{props.sale}</AnchorLink>
        </div>
        <div class="navbar-brand is-hidden-touch pt-2 pl-2 pr-2">
          <AnchorLink class="navbar-item" to={props.page + "#hero-section"} >
            <StaticImage
              src="../images/Logo.png"
              width={120}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Dutch Tyres"
            />
          </AnchorLink>
        </div>
        <div class="navbar-end">
          <AnchorLink className="navbar-item nav-links mainfont" to={props.page + "#about-section"} >{props.about}</AnchorLink>
          <a className="navbar-item nav-links mainfont" href="https://dutchtyres-lab.nl" target="_blank" rel="noopener noreferrer">{props.webshop}</a>
          <AnchorLink className="navbar-item nav-links mainfont" to={props.page + "#contact-section"} >{props.contact}</AnchorLink>
          <div class="navbar-item has-dropdown is-hoverable lang-dropdown">
            <a class="navbar-link is-arrowless">
              <Img fixed={data.allImageSharp.edges
                .find((element) =>
                {
                  if (element.node.fluid.src.split('/').pop() === props.selectedCountry + ".png")
                  {
                    return element;
                  }
                  return null;
                }).node.fluid} style={{ height: "25px", width: "25px" }} imgStyle={{ height: "25px", width: "25px" }} />
            </a>
            <div class="navbar-dropdown is-boxed is-dark" >
              <Link className="mainfont pl-3" to={props.countryLink}>
                <Img fixed={data.allImageSharp.edges
                  .find((element) =>
                  {
                    if (element.node.fluid.src.split('/').pop() === props.possibleCountry + ".png")
                    {
                      return element;
                    }
                    return null;
                  }).node.fluid} style={{ height: "25px", width: "25px" }} imgStyle={{ height: "25px", width: "25px" }} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav >
  )
}
export default Navbar;